import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { libConfig } from './app/app.config';

bootstrapApplication(AppComponent, libConfig).catch(() => undefined);
